import { useEffect } from "react";
import { getClientSubMenu } from "../../../../services/Auth/user.service";
import { isNullUndefinedOrEmpty } from "../../../../common/Helpers";
import moment from "moment";

const useGetClientSubMenu = (clientSubMenuItems, setClientSubMenuItems) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let site_menu_list = window.localStorage.getItem("SITE_MENU_LIST")
                let site_menu_list_date = window.localStorage.getItem("SITE_MENU_LIST_DATE")

                if (isNullUndefinedOrEmpty(site_menu_list) || isNullUndefinedOrEmpty(site_menu_list_date)) {
                    let serviceResponse = await getClientSubMenu();

                    const response = serviceResponse;
                    if (response.data.succeeded) {
                        window.localStorage.setItem("SITE_MENU_LIST", response.data.data)
                        window.localStorage.setItem("SITE_MENU_LIST_DATE", moment(Date.now()).format("YYYY-MM-DD"))
                        setClientSubMenuItems(response.data.data);
                    }
                    else {
                        //Posiblemente desplegar uno por defecto.
                        window.localStorage.setItem("SITE_MENU_LIST_DATE", moment(Date.now()).format("YYYY-MM-DD"))
                        setClientSubMenuItems([])
                    }
                }
                else {
                    const storedDateParsed = new Date(site_menu_list_date);
                    const currentDate = new Date();
                    const currentDateWithoutTime = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
                    const storedDateWithoutTime = new Date(storedDateParsed.getFullYear(), storedDateParsed.getMonth(), storedDateParsed.getDate());

                    if (storedDateWithoutTime < currentDateWithoutTime) {
                        let serviceResponse = await getClientSubMenu();
                        const response = serviceResponse;
                        if (response.data.succeeded) {
                            window.localStorage.setItem("SITE_MENU_LIST", response.data.data)
                            window.localStorage.setItem("SITE_MENU_LIST_DATE", moment(Date.now()).format("YYYY-MM-DD"))
                            setClientSubMenuItems(response.data.data);
                        }
                        else {
                            //Posiblemente desplegar uno por defecto.
                            window.localStorage.setItem("SITE_MENU_LIST_DATE", moment(Date.now()).format("YYYY-MM-DD"))
                            setClientSubMenuItems([])
                        }
                    }
                    else {
                        setClientSubMenuItems(site_menu_list);
                    }
                }
            }
            catch (error) {
                setClientSubMenuItems([])
            }
        }
        
        if (clientSubMenuItems === null) {
            getData()
        }
    }, [clientSubMenuItems, setClientSubMenuItems]);
}

export {
    useGetClientSubMenu
}